import TabViewState, { TabType } from '../store/schema/TabViewState';

interface TabHandler {
    onActivate?: (viewState: TabViewState) => void;
    onDeactivate?: (viewState: TabViewState) => void;
    canClose?: (viewState: TabViewState) => boolean | Promise<boolean>;
}

export default TabHandler;

const tabHandlers: { [type: string]: TabHandler } = {};

export function registerTabHandler(type: TabType, handler: TabHandler) {
    tabHandlers[TabType[type]] = handler;
}

export function getTabHandler(type: TabType): TabHandler {
    return tabHandlers[TabType[type]];
}
